// Canonical vocabulary for revenueTypes.mappedType.
// Mirror of azfApi/utils/revenueMappedTypes.js — keep in sync.
//
// 'Room Revenue' and 'DNI' carry hard-coded semantics in the report/dashboard
// SQL ('DNI' = Do Not Include). Other values are type buckets; the API also
// accepts custom per-property outlet labels (e.g. a restaurant name) — present
// this list as the suggested set, not the only set.
export const REVENUE_MAPPED_TYPES = [
  'Room Revenue',
  'F&B',
  'Banquet',
  'Other',
  'DNI',
];

export const RESERVED_REVENUE_MAPPED_TYPES = ['Room Revenue', 'DNI'];

export const ALLOW_CUSTOM_REVENUE_MAPPED_TYPES = true;

export default REVENUE_MAPPED_TYPES;
